import api from "./api";
import { config } from "./config.service";

const API_URL = config.host_api;

export const getProfile = (id) => {
  return api
    .get(`${API_URL}users/${id}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const getNationality = (id) => {
  return api
    .get(`${API_URL}user/nationality/${id}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const getImg = (photo) => {
  return api
    .get(`${API_URL}user/photo/${photo}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const editProfile = async (formData) => {
  return api.post(API_URL + "user/edit", formData);
};
